import { Component, ViewChild } from '@angular/core';
import { Registration } from 'src/app/shared/models/registration';
import { HoursOption } from 'src/app/shared/models/hours-option';
import { Worker } from 'src/app/shared/models/worker';

import { alert, confirm } from 'devextreme/ui/dialog';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { DxFileUploaderComponent, DxFormComponent } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { Constructionsite } from 'src/app/shared/models/constructionsite';
import { ConstructionPhase } from 'src/app/shared/models/construction-phase';

import ArrayStore from 'devextreme/data/array_store';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { LoggingService } from '../../shared/services/logging.service';
import { UploadedEvent, UploadErrorEvent } from 'devextreme/ui/file_uploader';
import { environment } from '../../../environments/environment';

import { RestApiService } from '../../shared/services/rest-api.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';


@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})

export class RegistrationComponent {
  @ViewChild(DxFormComponent, { static: false }) form! : DxFormComponent;
  @ViewChild('fileUploader') fileUploaderRef!: DxFileUploaderComponent;

  registration:  Registration | undefined;
  registrationId: number | null;
  
  option: HoursOption | undefined;
  currentWorker: Worker | undefined;

  forwardSubscription: any;
  backSubscription: any;

  // è true se derivo da un ritorno da un registrazione in modalità singola (non capocantiere)
  oreLavorateVisible = false;

  constructionSiteDataSubscription: any;
  constructionPhaseDataSubscription: any;
  costDataSubscription: any;

  notesEditorOptions: unknown;
  inizioFineEditorOptions: unknown;
  maxDate: string;

  constructionSitesStore: ArrayStore;
  constructionPhasesStore: ArrayStore;
  costsStore: ArrayStore;

  dataRegistrazioneEditorOptions: unknown;
  cantiereEditorOptions: unknown;
  faseEditorOptions: unknown;
  costoEditorOptions: unknown;

  files: any[] = [];
  guidDirectory = "";

  noteTxt: string;

  /*
  text2: string | undefined;
  text3: string | undefined;
  text4: string | undefined;*/

  // online/offline
  isOnline = true;
  private onlineListener = () => { this.setOnlineStatus(true); };
  private offlineListener = () => { this.setOnlineStatus(false); };
  private destroy$ = new Subject<void>();


  constructor(
    private restApi: RestApiService,
      private service: WorkerAndToolService,
      private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private logger: LoggingService,
      private router: Router,
    private workflowService: RegistrationWorkflowService) {
    this.notesEditorOptions = { height: 90 };
    this.registrationId = null;

    this.registration = service.getNewRegistration();
    this.maxDate = this.registration.dataRegistrazione.toISOString().split('T')[0];

    this.constructionSitesStore = new ArrayStore(
      {
        key: "constructionSiteCode",
      }
    )

    this.dataRegistrazioneEditorOptions = {
      dateSerializationFormat: "yyyy-MM-dd"

    };

    this.inizioFineEditorOptions = {
      type: "time",
      dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
    };

    this.cantiereEditorOptions = {
      dataSource: this.constructionSitesStore,
      searchEnabled: true,
      displayExpr: "constructionSiteDescription",
      valueExpr: "constructionSiteCode",
      showClearButton: true,
      searchExpr: "constructionSiteDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare il cantiere",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.constructionPhasesStore = new ArrayStore(
      {
        key: "constructionPhaseCode",
      }
    )

    this.faseEditorOptions = {
      dataSource: this.constructionPhasesStore,
      searchEnabled: true,
      displayExpr: "constructionPhaseDescription",
      valueExpr: "constructionPhaseCode",
      showClearButton: true,
      searchExpr: "constructionPhaseDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare la fase",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.costsStore = new ArrayStore({
      key: "costCode",
      
    });


    this.costoEditorOptions = {
      dataSource: this.costsStore,
      searchEnabled: true,
      displayExpr: "costDescription",
      valueExpr: "costCode",
      showClearButton: true,
      searchExpr: "costDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare il costo",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };


    this.noteTxt = "Note";
    if (this.option?.descriptionNotes1 != null && this.option.descriptionNotes1 != "") {
      this.noteTxt = this.option.descriptionNotes1;
    }

    // iniziale stato online
    this.isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
  }

  ngOnInit() {

    // registra listener online/offline
    if (typeof window !== 'undefined') {
      window.addEventListener('online', this.onlineListener);
      window.addEventListener('offline', this.offlineListener);
    }

    this.service.getHoursOption().then(val => {
      this.option = val;

      if (this.option?.prohibitFutureRegistrations) {
        this.dataRegistrazioneEditorOptions = {
          ...(this.dataRegistrazioneEditorOptions as object),
          max: this.maxDate
        };
      }

      this.impostaSalvaAvanti();
      this.impostaOreVisibile();

      this.loadCatalog();
    });

    this.backSubscription = this.toolbar.backClickedEvent.subscribe(() => this.Back());
    this.forwardSubscription = this.toolbar.forwardClickedEvent.subscribe(() => this.Forward());

    this.service.getCurrentWorker().then(val => {
      this.currentWorker = val;
      this.impostaSalvaAvanti();
      this.impostaOreVisibile();
    });

    this.toolbar.BackVisibleChanged(false);
    this.toolbar.CancelVisibleChanged(true);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);

    const regId = this.route.snapshot.paramMap.get('id');
    if (regId != null) this.registrationId = +regId;

    this.oreLavorateVisible = false;
    const back = this.route.snapshot.paramMap.get('back');
    if (back && back === "1") this.oreLavorateVisible = true;

  }


  private loadCatalog() {
    const useOnline = this.option?.useOnlineCatalog ?? false;


    if (useOnline && this.isOnline) {


      // gestione del titolo della toolbar 
      if (this.registrationId == null) {
        this.toolbar.TitleChanged("Nuova");
      } else {
        if (this.registrationId > 0) {
          this.toolbar.TitleChanged("Modifica");
        } else {
          const back = this.route.snapshot.paramMap.get('back');
          if (back) {
            this.toolbar.TitleChanged("Nuova");
          } else {
            this.toolbar.TitleChanged("Duplica");
          }
        }
      }


      // recupera dal backend via RestApiService
      this.restApi.getConstructionSites().pipe(takeUntil(this.destroy$)).subscribe({
        next: (sites: Constructionsite[]) => {
          // pulisco e inserisco
          this.constructionSitesStore.clear();
          sites.forEach(f => this.constructionSitesStore.insert(f));

          // opzionale: sincronizzo il DB locale per offline future
          this.service.syncConstructionSites(sites).catch(() => { /* ignoro errori */ });

          // poi carico i costi
          this.restApi.getCosts().pipe(takeUntil(this.destroy$)).subscribe({
            next: (costs: any[]) => {
              this.costsStore.clear();
              costs.forEach(f => this.costsStore.insert(f));
              this.service.syncCosts(costs).catch(() => { /* ignoro errori */ });

              // se siamo in modifica/duplicazione carico la registrazione temporanea
              if (this.registrationId) {
                this.service.getTempRegistration(this.registrationId).then((reg) => this.registration = reg);
              }
            },
            error: () => {
              // fallback: usa DB locale se chiamata online fallisce
              this.service.getCosts().then(vals => vals.forEach(f => this.costsStore.insert(f)));
            }
          });
        },
        error: () => {
          // fallback: uso DB locale se chiamata online fallisce
          Promise.all([this.service.getConstructionSites(), this.service.getCosts()])
            .then((values) => {
              values[0].forEach(f => this.constructionSitesStore.insert(f));
              values[1].forEach(f => this.costsStore.insert(f));
              if (this.registrationId) {
                this.service.getTempRegistration(this.registrationId).then((reg) => this.registration = reg);
              }
            });
        }
      });
    }
    else {

      if (this.registrationId == null) {
        this.toolbar.TitleChanged("Nuova");

        Promise.all([this.service.getConstructionSites(), this.service.getCosts()])
          .then(
            (values) => {
              values[0].forEach(f => this.constructionSitesStore.insert(f));
              values[1].forEach(f => this.costsStore.insert(f));
            })
      }
      else {
        if (this.registrationId > 0) {
          this.toolbar.TitleChanged("Modifica");
        }
        else {
          const back = this.route.snapshot.paramMap.get('back');
          if (back) {
            this.toolbar.TitleChanged("Nuova");
          }
          else {
            this.toolbar.TitleChanged("Duplica");
          }

        }

        Promise.all([this.service.getConstructionSites(), this.service.getCosts()])
          .then(
            (values) => {
              values[0].forEach(f => this.constructionSitesStore.insert(f));
              values[1].forEach(f => this.costsStore.insert(f));

              if (this.registrationId) {
                this.service.getTempRegistration(this.registrationId).then((reg) => this.registration = reg);
              }
            })
      }

    }
  }


  private setOnlineStatus(val: boolean) {
    this.isOnline = val;
    // puoi aggiungere log o UI feedback qui
    console.log('Online status:', this.isOnline);
  }

  impostaSalvaAvanti() {
    if (this.option && this.currentWorker && !this.option.toolRegistrationsEnabled && !this.currentWorker.siteManagerMode) {
      this.toolbar.SaveVisibleChanged(true);
      this.toolbar.ForwardVisibleChanged(false);
    }
    else {
      this.toolbar.SaveVisibleChanged(false);
      this.toolbar.ForwardVisibleChanged(true);
    }
  }

  impostaOreVisibile() {
    if (this.option && this.currentWorker && !this.currentWorker.siteManagerMode) {
      this.oreLavorateVisible = true;
    }
  }

  ngOnDestroy() {
    this.backSubscription.unsubscribe();
    this.forwardSubscription.unsubscribe();

    // rimuovo listener online/offline
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', this.onlineListener);
      window.removeEventListener('offline', this.offlineListener);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFieldDataChanged(e: FieldDataChangedEvent) {
    if (e.dataField === "cantiere") {

      this.constructionPhasesStore.clear();
      this.service.getConstructionPhases(e.value).then(
        phases => {
          phases.forEach(f => this.constructionPhasesStore.insert(f));
          if (this.registration && this.registration.fase) {
            if (!phases.find(f => this.registration && f.constructionPhaseCode == this.registration.fase)) {
              this.registration.fase = null;
            }            
          }

          this.form.instance.getEditor("fase")?.repaint();
      });
    }
  }

  onUploadError(e: UploadErrorEvent): void {
    const xhttp = e.request;
    if (xhttp.status === 400) {
      e.message = e.error.responseText;
    }
    if (xhttp.readyState === 4 && xhttp.status === 0) {
      e.message = 'Collegamento Fallito';
    }
    //this.retryButtonVisible = true;
  }

  onUploaded(e: UploadedEvent): void {

    if (this.registration) {
      if (!this.registration.attachments) {
        this.registration.attachments = [];
      }

      this.registration.attachments.push(e.file.name);
    }
    
  }

  onFileUploaderValueChanged(e: any): void {
    //creo un guid per creare la cartella in cui archiviare
    if (this.registration) {
      if (this.registration.filesDir == null) {
        this.guidDirectory = "";
      }
      else {
        this.guidDirectory = this.registration.filesDir;
      }
    }

    if (this.guidDirectory == "") {
      this.guidDirectory = this.service.getUniqueId(4);
    }

    this.fileUploaderRef.uploadUrl = environment.ApiUrl + '/api/FileUpload/PostFiles?uuid=' + this.guidDirectory;
    if (this.registration) {
      this.registration.filesDir = this.guidDirectory;
    }
  }

  Back()
  {
    const result = confirm("<i>Sei sicuro?</i><br>I dati inseriti andranno persi", "Conferma Abbandono");
        result.then((dialogResult) => {
            if (dialogResult)
            {
                // Torno all'indice
                this.router.navigate(['/registrations']);
            }
        });
  }

  Forward()
  {
    const result = this.form.instance.validate();

    if (result.isValid && this.registration != null && this.currentWorker) {



      // Worker singolo (non siteManager) senza fasi multiple: crea registrazione inline
      if (!this.currentWorker.siteManagerMode && !this.option?.multiplePhases) {
        let oreLavorate = this.registration.oreLavorate;
        oreLavorate ??= 8;

        this.registration.workerRegistrations.splice(0);
        this.registration.workerRegistrations.push(
          {
            workerNumber: this.currentWorker.workerNumber,
            workerDescription: this.currentWorker.surname + ' ' + this.currentWorker.name,
            oreLavorate: oreLavorate,
            toolCode: null,
            phaseCode: null,
            phaseDescription: null,
            keyIdentification: null,
            cost: "",
          });
      }

      const ctx: WorkflowContext = { options: this.option!, siteManagerMode: this.currentWorker.siteManagerMode, hasControls: false };
      const nextStep = this.workflowService.getNextStep('registration', ctx);

      // Valida MaxRegistrationHours subito, prima di salvare il draft e navigare:
      // nel flow non-siteManagerMode le workerRegistrations sono già popolate con
      // le ore dell'utente corrente e l'errore deve scattare sulla pagina iniziale,
      // non al save finale dopo che l'utente ha già percorso più step del workflow.
      this.service.validateMaxRegistrationHours(this.registration, this.registrationId ?? undefined)
        .then(() => {
          if (nextStep) {
            if (this.registrationId == null) {
              this.service.addTempRegistration(this.registration!).then((regId) => this.router.navigate(['/' + nextStep, { id: regId }]))
            } else {
              this.service.editTempRegistration(this.registration!, this.registrationId).then((regId) => this.router.navigate(['/' + nextStep, { id: regId }]))
            }
          } else {
            if (this.registrationId == null || this.registrationId < 0) {
              this.service.addRegistration(this.registration!).then(() => this.router.navigate(['/registrations']))
                .catch(err => { if (!this.service.showSaveError(err)) throw err; });
            } else {
              this.service.editRegistration(this.registration!, this.registrationId).then(() => this.router.navigate(['/registrations']))
                .catch(err => { if (!this.service.showSaveError(err)) throw err; });
            }
          }
        })
        .catch(err => { if (!this.service.showSaveError(err)) throw err; });
    }
    else if (this.registration == null) {
      // Se il valore è nullo o indefinito invio un messaggio
      alert("Nessuna registrazione individuata", "Errore");
    }
    else if (this.currentWorker == null) {
      // Se il valore è nullo o indefinito invio un messaggio
      const user = localStorage.getItem("user");

      alert("Nessun lavoratore con il codice '" + user + "'", "Errore");
      this.service.getWorkers().then((workers) => workers.forEach(w => this.logger.logError("Nessun lavoratore con il codice '" + user + "'", JSON.stringify(w))));
    }

  }
}
